<template>
  <div class="modal_wrapper active">
    <div class="modal_window white_box create_report_modal">
      <button
        class="close_modal close_btn"
        @click="closeModal()"
      >
        <svg
          fill="none"
          height="32"
          viewBox="0 0 32 32"
          width="32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25 7L7 25"
            stroke="#040707"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            d="M25 25L7 7"
            stroke="#040707"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
        </svg>
      </button>

      <h3 class="heading_h4 font_bold mb_16">
        {{ widgetModal.widget ? 'Edit' : 'Create' }} Image Widget
      </h3>

      <div :class="'section_wrap '+(settings === 'widget' ? 'open' : '')">
        <div
          class="section_head"
          @click="(settings === 'widget' ? settings = '' : settings = 'widget')"
        >
          <h3 class="section_heading">
            Widget Settings
          </h3>
          <i class="icon arrow_down_icon caret" />
        </div>
        <accordion-transition>
          <div
            v-if="settings === 'widget'"
            class="section_body"
          >
            <custom-input
              v-model="widget.name"
              label="Widget name"
              placeholder="Enter a title for the widget (optional)"
              width="full"
            />

            <div class="toggles">
              <custom-toggle
                v-model="widget.attributes.isLink"
                label="Make the image a link"
                width="third"
              />
            </div>

            <custom-input
              v-if="widget.attributes.isLink"
              v-model="widget.attributes.href"
              label="Link to url"
              placeholder="Enter a url to link to e.g. https://www.google.com"
              width="full"
            />

            <img
              v-if="widget.attributes.src"
              :src="widget.attributes.src"
              class="img-preview"
            >

            <custom-image-upload
              v-model="widget.attributes.src"
              :label="widget.attributes.src ? 'Select a new image' : 'Select an image' "
              width="full"
            />
          </div>
        </accordion-transition>
      </div>

      <div class="flex items-center section_modal_footer">
        <button
          class="btn btn_md secondary_btn close_modal ml_auto mr_8"
          @click="closeModal()"
        >
          <span>Cancel</span>
        </button>
        <button
          class="btn btn_md primary_btn"
          @click="save()"
        >
          <span>{{ widgetModal.widget ? 'Update' : 'Create' }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import _ from 'lodash';
import CustomInput from '../../global/forms/CustomInput.vue';
import CustomImageUpload from '../../global/forms/CustomImageUpload.vue';
import CustomToggle from '../../global/forms/CustomToggle.vue';
import AccordionTransition from '../../global/transitions/AccordionTransition.vue';

export default {
  components: {
    CustomInput,
    CustomImageUpload,
    CustomToggle,
    AccordionTransition
  },
  emits: ['refresh-widget'],
  data() {
    return {
      settings: 'widget',
      widget: {
        id: `widget-image-${Date.now()}`,
        name: 'Image Widget',
        type: 'image',
        w: 6,
        h: 25,
        attributes: {
          isLink: false,
          href: '',
          src: '',
        },
        content: ''
      }
    }
  },
  computed: {
    ...mapState(['widgetModal'])
  },
  beforeMount() {
    if (this.widgetModal.widget) _.merge(this.widget, this.widgetModal.widget);
  },
  methods: {
    ...mapActions('pages', ['addWidget', 'updateWidget']),
    ...mapActions('widgetModal', ['closeModal']),
    async save() {
      if (this.widget.attributes.isLink) {
        this.widget.content = `<a href="${this.widget.attributes.href}" target="_blank"><img src="${this.widget.attributes.src}" class="grid-image"></a>`;
      } else {
        this.widget.content = `<img src="${this.widget.attributes.src}" class="grid-image">`;
      }

      // Prep a payload for the vuex action
      const payload = {
        widget: this.widget,
        pageId: this.widgetModal.pageId,
      }

      // Check if we're creating a new widget or editing one
      if (!this.widgetModal.widget) {
        // Save the new pages layout (refreshes store pages)
        await this.addWidget(payload);
      } else {
        // Update the widget
        await this.updateWidget(payload);
      }

      // Emit to trigger widget refresh, then close the modal
      this.$emit('refresh-widget', {pageId: this.widgetModal.pageId, widget: this.widget});
      this.closeModal();
    }
  },
}
</script>

<style scoped src="../../../../reports/css/modal.css" />

<style scoped>
.img-preview {
  width: 100%;
  height: 400px;
  object-fit: contain;
  margin-bottom: 15px;
}
</style>
